import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

// Create a custom axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add currency header if available in localStorage; default to ILS otherwise.
    const currency = localStorage.getItem("app_currency");
    config.headers["X-Currency"] = currency || "ILS";

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling (optional)
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    // Handle common errors here
    if (error.response?.status === 401) {
      // Unauthorized - clear token and let React handle the redirect
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      
      // Dispatch a custom event to notify the app about logout
      window.dispatchEvent(new CustomEvent('auth:logout'));
    }

    // Pass the error along to be handled by the specific service
    return Promise.reject(error);
  }
);

// Export a function to create a new instance with custom config
export const createApiInstance = (
  config?: InternalAxiosRequestConfig
): AxiosInstance => {
  return axios.create({
    ...config,
    baseURL: API_URL,
  });
};

export default axiosInstance;
